<template>
  <div class="public-title">
   <div class="public-content">
     {{ title }}
  </div> 
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
  },
};
</script>

<style scoped>
.public-title {
  /* position: absolute; */
  /* top: -4.5%; */
  width: 100%;
  height: 10%;
  background-image: url("../../assets/image/bgm.png");
  background-size: 100% 100%;
  /* left: 33.6%; */
  
}
.public-content{
  margin-left: 9%;
  color: #9ad6d4;
   font-size: 15px;
}
</style>